<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">New Job Work Type</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Job Type" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="copy.title"></o-input>
                </o-field>

                <o-field label="Price" :type="fieldType('price')" :message="getError('price')">
                    <o-input v-model="copy.price"></o-input>
                </o-field>

                <div class="field">
                    <o-checkbox v-model="copy.is_active">
                        {{ copy.is_active ? 'Active' : 'Inactive' }}
                    </o-checkbox>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="handleSubmit" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import HandlesForm from './../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        methods: {
            ...mapActions(['createOrUpdateWorkType']),

            handleSubmit () {
                let submit = this.wrapSubmit(this.createOrUpdateWorkType)

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Work Type has been successfull created')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        },
    }</script>
